import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MemberSelection, PersonPreview } from '@core/api/services/portal-member-import.service';

interface ContactRow {
  label: string;
  values: string[];
  selection: 'email' | 'phone' | 'address';
  inputType: 'email' | 'tel' | 'text';
}

@Component({
  selector: 'app-contact-import-comparison',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `<section class="comparison">
    <table aria-label="Datos de contacto a importar">
      <thead><tr><th scope="col">Dato</th><th scope="col">Portal</th><th scope="col">Valor a importar</th></tr></thead>
      <tbody><tr *ngFor="let row of rows; trackBy: trackRow" [attr.data-import-pending]="needsReview(row) ? '' : null">
        <td>{{ row.label }}</td>
        <td>{{ row.values.join(' · ') }}</td>
        <td><input class="contact-editable-input" [type]="row.inputType" [attr.aria-label]="row.label + ' a importar'" placeholder="No importar" autocomplete="off" [(ngModel)]="selection[row.selection]"></td>
      </tr></tbody>
    </table>
  </section>`,
  styles: [`table{width:100%;border-collapse:collapse;table-layout:fixed}th,td{padding:.45rem .65rem;text-align:left;overflow-wrap:anywhere}th:first-child{width:18%}th{background:#edf6fb;color:#174d78;font-size:.73rem;font-weight:700}td{border-top:1px solid #e2edf4;color:#49616f;font-size:.76rem}.contact-editable-input{box-sizing:border-box;width:100%;min-height:2rem;padding:.25rem 0;border:0;border-bottom:1px solid #607d8b;background:transparent;color:#174d78;font:inherit;font-weight:600}.contact-editable-input:focus{outline:0;border-bottom:2px solid #2d7fbd}.contact-editable-input::placeholder{color:#78909c;font-weight:400;opacity:1}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactImportComparisonComponent {
  needsReview(row: ContactRow): boolean {
    const pattern = row.selection === 'email' ? /correo|email/ : row.selection === 'phone' ? /teléfono|telefono/ : /dirección|direccion/;
    return this.selection[row.selection] === undefined && (row.values.length > 0 || this.member.warnings.some(warning => pattern.test(warning.toLocaleLowerCase())));
  }
  @Input({ required: true }) member!: PersonPreview;
  @Input({ required: true }) selection!: MemberSelection;
  trackRow(_index: number, row: ContactRow): string { return row.selection; }

  get rows(): ContactRow[] {
    const rows: ContactRow[] = [
      { label: 'Email', values: this.member.emails, selection: 'email', inputType: 'email' },
      { label: 'Teléfono', values: this.member.phones, selection: 'phone', inputType: 'tel' },
      { label: 'Dirección', values: this.member.addresses, selection: 'address', inputType: 'text' },
    ];
    return rows;
  }
}
